module.exports = __webpack_public_path__ + "media/images/main_visual@2x-c32720386803970a21321fe06ba438aa.png";